<template>
	<MainContainer
		header-selected="help"
		:loading="status == 'pending'"
		:fetched="status == 'success'"
		:error="error"
		no-company-branding
		@try-again="refresh"
	>
		<HelpBreadcrumb
			:links="[
				{
					name: $t('home'),
					to: $routeUrl.HomeUrl()
				},
				{
					name: $t('help'),
					to: $routeUrl.HelpUrl()
				},
				{
					name: $stringUtil.getLocalText(category?.title) || '',
					to: ''
				}
			]"
		/>
		<HelpCategoryHeroSection :category="category || undefined" />
		<div ref="contentContainerEl" class="flex flex-col px-4 pb-20 pt-20">
			<div class="flex w-full max-w-screen-xl flex-col self-center">
				<div class="mb-6 flex items-center">
					<span class="flex-grow text-2xl font-bold text-slate-950">
						{{ $t("latest_helps") + (page > 1 ? ` (${$t("page_n", { page })})` : "") }}
					</span>
					<span class="text-slate-400 text-xs">
						{{ $t("n_helps", { n: data?.post_data?.total }, data?.post_data?.total || 0) }}
					</span>
				</div>
				<div class="grid w-full max-w-screen-xl grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-2 lg:grid-cols-3">
					<NuxtLink
						v-for="post in data?.post_data?.posts"
						:key="post.id"
						:to="$routeUrl.HelpPostUrl(post.id)"
						class="flex flex-col"
					>
						<HelpPostCard :post="post" class="flex-grow" />
					</NuxtLink>
					<BaseEmptyBox v-if="!data?.post_data?.posts?.length" class="col-span-3 my-24" />
				</div>
				<div
					v-if="data?.post_data?.total"
					class="border-slate-400 mt-20 flex flex-col rounded-lg border bg-gradient-to-t from-slate-50 to-white px-3 py-3"
				>
					<BasePagination
						:current="page"
						:total="data?.post_data?.total || 0"
						:limit="state.limit"
						:link="
							(p) => (category ? $routeUrl.HelpCategoryPageUrl(category.id, p) : $routeUrl.HelpPageUrl(p))
						"
						class="self-center"
					/>
				</div>
			</div>
		</div>
	</MainContainer>
</template>

<script lang="ts" setup>
const categoryStore = useCategoryStore()
const cmsStore = useCmsStore()
const app = useNuxtApp()
const route = useRoute()

const state = reactive({
	limit: 12
})

const contentContainerEl = shallowRef<HTMLElement>()

const categoryId = computed(() => Number(route.params.categoryId) || null)
const page = computed(() => Math.max(1, Number(route.params.page) || 1))
const qSearchText = computed(() => String(route.query.s || ""))

const categories = computed(() => categoryStore.categories?.filter((c) => c.type == "help") || [])
const category = computed(() => categories.value.find((c) => c.id == categoryId.value) || null)

const { data, status, error, refresh } = useLazyAsyncData(
	String(route.path),
	() =>
		cmsStore.contentBundle({
			company_id: null,
			queries: [
				{
					query_name: "post_data" as const,
					query_type: "posts",
					types: "help",
					page: page.value,
					limit: state.limit,
					search: qSearchText.value,
					category_ids: String(categoryId.value || "") || undefined
				},
				{
					query_name: "most_popular_post_data" as const,
					query_type: "posts",
					types: "help",
					page: 1,
					limit: 4,
					search: qSearchText.value,
					category_ids: String(categoryId.value || "") || undefined,
					has_image: true
				}
			]
		}),
	{
		watch: [() => route.query]
	}
)

const goToArticles = (smooth: boolean = true) => {
	console.log("ddd")
	if (!contentContainerEl.value) return
	console.log("ddd2")
	useTimeoutFn(() => {
		if (!contentContainerEl.value) return
		window.scrollTo({
			top: contentContainerEl.value.offsetTop - 64,
			behavior: smooth ? "smooth" : "instant"
		})
	}, 1)
}

watch(
	() => [page.value, contentContainerEl.value],
	() => {
		if (page.value == 1) return
		goToArticles(false)
	}
)

useHead(() => ({
	title: category.value
		? app.$i18n.t("category_of_n", { name: app.$stringUtil.getLocalText(category.value.title) }) +
			" | " +
			app.$i18n.t("app_help")
		: app.$i18n.t("app_help") + " | " + app.$i18n.t("app_motto")
}))
</script>
